// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentBox_wrapper__UHf0M","selectable":"ContentBox_selectable__slx6f","padding":"ContentBox_padding__XhJam"};